import { PrimaryButton } from "@parksandresorts/core";
import styles from "./waiting-room-display.module.less";
import MyPageLoader from "components/block-elements/my-page-loader/my-page-loader";
import SiteConfigurationStore from "components/stores/site-configuration-store";

const WaitingRoomDisplay = ({
  waitingRoomLogo,
  message,
  placeInQueue,
  isLoading,
  isLocked,
  isInQueue,
  onRestartQueue,
  maxSecondsInQueue,
  error,
}) => {
  const renderBody = () => {
    if (isLocked) {
      return (
        <div className={styles.loader}>
          <h2 className={styles.loaderHeading}>
            {SiteConfigurationStore.getLabel("WAITING_ROOM_PAGE_LOCKED", "Sidan är låst")}
          </h2>
        </div>
      );
    }

    if (isLoading) {
      return (
        <div className={styles.loader}>
          <h2 className={styles.loaderHeading}>
            {SiteConfigurationStore.getLabel("WAITING_ROOM_LOADING", "Laddar...")}
          </h2>
          <MyPageLoader />
        </div>
      );
    }

    if (error) {
      return (
        <div className={styles.errorWrapper}>
          <h2 className={styles.errorHeading}>
            {SiteConfigurationStore.getLabel("WAITING_ROOM_ERROR", "Ett fel har inträffat")}
          </h2>
          <p className={styles.errorBody}>{error}</p>
          <PrimaryButton
            label={SiteConfigurationStore.getLabel("WAITING_ROOM_ERROR_BUTTON", "Prova igen")}
            className={["waves-effect", styles.rejoinQueueButton].join(" ")}
            onClick={onRestartQueue}
          />
        </div>
      );
    }

    if (isInQueue) {
      const maxNumberOfMinutes = maxSecondsInQueue / 60;
      return (
        <div className={styles.queueStatusWrapper}>
          <h3 className={styles.queueHeading}>
            {SiteConfigurationStore.getLabel("WAITING_ROOM_QUEUE_HEADING", "Du är placerad i kö")}
          </h3>
          <p className={[styles.queueBody, "p_small"].join(" ")}>
            {SiteConfigurationStore.getLabel(
              "WAITING_ROOM_QUEUE_BODY_1",
              "Just nu är det många som vill köpa biljetter samtidigt. När det är din tur kommer du ha ",
            )}
            {isNaN(maxNumberOfMinutes) ? "15" : maxNumberOfMinutes}
            {SiteConfigurationStore.getLabel("WAITING_ROOM_QUEUE_BODY_2", " minuter på dig att köpa dina biljetter.")}
          </p>
          <p className={[styles.queueBody, "p_small"].join(" ")}>
            {SiteConfigurationStore.getLabel(
              "WAITING_ROOM_QUEUE_BODY_3",
              "Du behöver inte göra något mer än att vänta kvar här och hålla koll på kön. Du kommer automatiskt till köpflödet. Tack för ditt tålamod!",
            )}
          </p>
          <p></p>
          <div className={styles.ticketWrapper}>
            <div className={styles.backgroundPattern} />
            <h6 className={styles.ticketHeadline}>
              {SiteConfigurationStore.getLabel("WAITING_ROOM_TICKET_HEADLINE", "Köbiljett")}
            </h6>
            <h2 className={styles.positionInQueue}>{placeInQueue}</h2>
            <p className={[styles.positionInQueueDescription, "p_small"].join(" ")}>
              {SiteConfigurationStore.getLabel("WAITING_ROOM_TICKET_BODY", "plats i kön")}
            </p>

            <div className={styles.ticketDivider}>
              <div className={styles.innerWrapper}>
                <div className={styles.circleOne} />
                <div className={styles.line} />
                <div className={styles.circleTwo} />
              </div>
              <div className={styles.shadowRemoverOne} />
              <div className={styles.shadowRemoverTwo} />
            </div>

            <div className={styles.messageAreaWrapper}>
              {message ? (
                <div className={styles.messageWrapper}>
                  <h6 className={styles.messageHeadline}>
                    {SiteConfigurationStore.getLabel("WAITING_ROOM_MESSAGE_HEADLINE", "Meddelande")}
                  </h6>
                  <p className={[styles.messageParagraph, "p_small"].join(" ")}>{message}</p>
                </div>
              ) : (
                <div className={styles.messagePlaceholderWrapper}>
                  <img
                    className={styles.logo}
                    src={waitingRoomLogo ? waitingRoomLogo : "/images/my-pages/grona-lund-logo.svg"}
                    alt="Gröna Lund logo"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={styles.leftQueueWrapper}>
        <h3 className={styles.leftQueueHeading}>
          {SiteConfigurationStore.getLabel("WAITING_ROOM_LEFT_QUEUE_HEADLINE", "Status")}
        </h3>
        <p className={styles.leftQueueBody}>
          {SiteConfigurationStore.getLabel(
            "WAITING_ROOM_LEFT_QUEUE_BODY",
            "⌛ Sessionen gick ut! Tryck på knappen nedan för att ställa dig i kö till köpflödet igen.",
          )}
        </p>
        <PrimaryButton
          label={SiteConfigurationStore.getLabel("WAITING_ROOM_LEFT_QUEUE_BUTTON", "Gå med i kön igen")}
          className={["waves-effect", styles.rejoinQueueButton].join(" ")}
          onClick={onRestartQueue}
        />
      </div>
    );
  };

  return (
    <div className={styles.wrapper}>
      <div className="block--max-width-narrow">{renderBody()}</div>
    </div>
  );
};

WaitingRoomDisplay.propTypes = {};
WaitingRoomDisplay.defaultProps = {};
export default WaitingRoomDisplay;
